<template lang="pug">
div
  el-divider 编号规则
  el-form-item(label-width="0")
    .flex
      el-select.width-full(v-model="ruleId", filterable, @change="setTableName")
        el-option(v-for="{ ruleName: cnName, ruleId: id } in list", :key="id", :value="id", :label="cnName")
          .option
            .option-label {{ cnName }}
            i.option-icon.el-icon-edit(@click.stop="editOption(id)")
      i.icon.el-icon-plus(@click="openAdd")
      i.icon.el-icon-refresh(@click="getRule(true)")
</template>
<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { openSetIdentifier } from "@/CommonDP/components/custom-dialog";
import { serialNo_rule_list } from "@/CommonDP/service/serialNo-rule.js";
let cache;
export default {
  mixins: [settingMixin],
  inject: ["serverFieldList", "subformFieldList", "isSubFormChildWidget"],
  data() {
    return { list: [] };
  },
  computed: {
    ...mapVFOptions({ ruleId: "ruleId", table: "tableName" }),
    fieldList() {
      return this.isSubFormChildWidget() ? this.subformFieldList() : this.serverFieldList;
    },
    tableName() {
      return this.fieldList.find(({ tableName }) => tableName)?.tableName;
    }
  },
  created() {
    this.getRule();
  },
  methods: {
    async getRule(force = false) {
      this.list = [];
      if (force) cache = undefined;
      const fetch = cache || serialNo_rule_list();
      const { data } = await fetch;
      this.list = data;
    },
    async openAdd() {
      const { tableName } = this;
      const id = await openSetIdentifier({ tableName });
      if (id) {
        await this.getRule(true);
        this.ruleId = id;
        this.setTableName();
      }
    },
    setTableName() {
      this.table = this.tableName;
    },
    async editOption(ruleId) {
      const { tableName } = this;
      await openSetIdentifier({ tableName, ruleId });
      await this.getRule(true);
      this.setTableName();
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
